import router from '../../router';
import store from '../../store';
import axios from 'axios';

export default {
    checkExpiredToken: function(response) {
        return new Promise(
            function(resolve) {
                //If token is expired, refresh token, resubmit original request & resolve response for original request
                if (response.status === 401) {
                    // && response.data.error.code === 'GEN-TOKEN-EXPIRED') {
                    if (response.url === 'api/token') {
                        store.dispatch('authentication/loginFailed');
                    } else {
                        store.dispatch('authentication/tokenExpired');
                        localStorage.removeItem('id_token');
                        store.dispatch('users/logoutUser');
                    }
                    router.push({
                        name: 'Login'
                    });
                }
                // Otherwise just resolve the current response
                resolve(response);
            }.bind(this)
        );
    },
    user: {
        profile: null
    },
    check() {
        if (localStorage.getItem('id_token') !== null) {
            axios.get('api/user').then(response => {
                this.user.profile = response.data.data;
            });
        }
    },
    login(context, username, password) {
        return axios.post('/auth/token', {
            username: username,
            password: password
        });
    },
    logout() {
        axios.get('/auth/logout').then(response => {
            localStorage.removeItem('id_token');
            store.dispatch('users/logoutUser');
            this.user.profile = null;
            router.push({
                name: 'Login'
            });
        });
    },

    loggedIn() {
        return localStorage.getItem('id_token') !== null && localStorage.getItem('id_token') !== '';
    }
};
